import React from 'react';
import {
    Box,
    Paper,
    List,
    ListItem,
    ListItemText,
    Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';

// ✨ Changed: Renamed to be more descriptive and updated styles to match the table container.
const StyledListContainer = styled(Paper)(({ theme }) => ({
    backgroundColor: '#202020',
    borderRadius: '12px',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
    // We can remove padding here if the List component handles it, or keep it for a consistent outer shell.
    // Let's keep it simple and let the List itself have padding.
}));

// ✨ Changed: Matched the style of the "Payment Management" title.
const SectionTitle = styled(Typography)({
    marginBottom: '1rem',
    color: '#12c099',
    fontWeight: 'bold',
});

// ✨ Added: A dedicated styled component for links to keep code clean and reusable.
const StyledLink = styled('a')({
    color: '#12c099',
    textDecoration: 'none',
    fontWeight: 'bold',
    fontSize: '1rem',
    '&:hover': {
        textDecoration: 'underline',
    },
});

const Reservations = ({ reservations }) => {
    // This console log is good for debugging, can be kept or removed.
    console.log(`🎟️ Reservations Data Received:`, reservations);

    return (
        // ✨ Added: A Box wrapper for consistent layout and spacing, just like in PaymentManagement.
        <Box sx={{ mt: 4 }}>
            <SectionTitle variant="h4">
                Reservations
            </SectionTitle>

            <StyledListContainer>
                <List sx={{ padding: 0 /* Remove default list padding */ }}>
                    {reservations.map((reservation, index) => (
                        <ListItem
                            key={index}
                            sx={{
                                borderBottom: '1px solid #404040',
                                // ✨ Added: Hover effect to match the table rows.
                                '&:hover': {
                                    backgroundColor: '#2b2b2b',
                                },
                                // Ensure the last item doesn't have a border
                                '&:last-child': {
                                    borderBottom: 'none',
                                },
                                padding: '16px 20px', // ✨ Added: Consistent padding like the table cells.
                            }}
                        >
                            <ListItemText
                                primary={
                                    <StyledLink
                                        href={`https://admin.marsreel.com/${reservation.type}/${reservation.firebaseUid}`}
                                        target="_blank" // Good practice to open external links in a new tab
                                        rel="noopener noreferrer"
                                    >
                                        {reservation.name} ({reservation.type})
                                    </StyledLink>
                                }
                            />
                        </ListItem>
                    ))}
                </List>
            </StyledListContainer>
        </Box>
    );
};

export default Reservations;